import { mergeAttributes } from '@tiptap/core';
import TiptapLink, { LinkOptions } from '@tiptap/extension-link';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { isValidUrl } from './isValidUrl';

export const linkClassName = 'confidence-editor-link';

const createLinkPastePlugin = () => {
  return new Plugin({
    key: new PluginKey('linkPasteHandler'),
    props: {
      handlePaste: (view, event) => {
        const { selection } = view.state;

        if (selection.empty) return false;

        const pastedText = event.clipboardData?.getData('text/plain');
        if (!pastedText || !isValidUrl(pastedText)) return false;

        view.dispatch(
          view.state.tr.addMark(
            selection.from,
            selection.to,
            view.state.schema.marks.link.create({ href: pastedText }),
          ),
        );

        event.preventDefault();
        return true;
      },
    },
  });
};

export const Link = TiptapLink.extend<LinkOptions>({
  addProseMirrorPlugins() {
    return [createLinkPastePlugin()];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'a',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: linkClassName,
        rel: 'noopener noreferrer',
        target: '_blank',
      }),
      0,
    ];
  },
});
